import { blob } from '@/lib/fetch';

const EXTENSIONS: Record<string, string> = {
  'application/pdf': 'pdf',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/gif': 'gif',
  'image/heic': 'heic',
  'video/mp4': 'mp4',
  'video/quicktime': 'mov',
  'audio/ogg': 'ogg',
  'audio/mpeg': 'mp3',
  'audio/mp4': 'm4a',
};

/** True on a phone or tablet whose browser can hand a file to the OS share sheet. */
export function canShareFiles() {
  if (typeof navigator === 'undefined' || !navigator.share || !navigator.canShare) return false;
  if (!window.matchMedia('(pointer: coarse)').matches) return false;
  return navigator.canShare({ files: [new File([''], 'probe.pdf', { type: 'application/pdf' })] });
}

export function withExtension(name: string, type: string) {
  const extension = EXTENSIONS[type];
  if (!extension || /\.[a-z0-9]{2,5}$/i.test(name)) return name;
  return `${name}.${extension}`;
}

/** Open the share sheet with the file itself, so Save to Files, Print, Mail and WhatsApp get the PDF or image, not a link. */
export async function shareFile(url: string, name: string) {
  const absolute = new URL(url, window.location.href).href;
  let file: File | null = null;
  try {
    const data = await blob(absolute);
    if (!data) return;
    const type = data.type && data.type !== 'application/octet-stream' ? data.type : /\.pdf$/i.test(name) ? 'application/pdf' : data.type;
    file = new File([data], withExtension(name, type), { type });
  } catch {
    // A bucket without CORS cannot be read here. Sharing the link still works.
  }
  try {
    await navigator.share(file && navigator.canShare({ files: [file] }) ? { files: [file], title: name } : { url: absolute, title: name });
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') return;
    throw error;
  }
}
